import Criteria from './Criteria'

export default class AgentFields extends Criteria{

  getProperties() {
    return [
      {cac_descricao: 'Custom Field Fixo 1', cac_codigo: '1'},
      {cac_descricao: 'Custom Field Fixo 2', cac_codigo: '2'},
      {cac_descricao: 'Custom Field Fixo 3', cac_codigo: '3'},
      {cac_descricao: 'Custom Field Fixo 4', cac_codigo: '4'},
      {cac_descricao: 'Custom Field Fixo 5', cac_codigo: '5'},
      {cac_descricao: 'Custom Field Fixo 6', cac_codigo: '6'},
      {cac_descricao: 'Custom Field Fixo 7', cac_codigo: '7'},
      {cac_descricao: 'Custom Field Fixo 8', cac_codigo: '8'},
      {cac_descricao: 'Custom Field Fixo 9', cac_codigo: '9'},
      {cac_descricao: 'Custom Field Fixo 10', cac_codigo: '10'},
      {cac_descricao: 'Email', cac_codigo: 'email'},
      {cac_descricao: 'Identificador Alternativo', cac_codigo: 'alternativeIdentifier'},
      {cac_descricao: 'Nome', cac_codigo: 'name'},
      {cac_descricao: 'Celular DDD', cac_codigo: 'cellphoneIdd'},
      {cac_descricao: 'Celular STD', cac_codigo: 'cellphoneStd'},
      {cac_descricao: 'Número Celular', cac_codigo: 'cellphone'},
      {cac_descricao: 'Telefone DDD', cac_codigo: 'phoneIdd'},
      {cac_descricao: 'Telefone STD', cac_codigo: 'phoneStd'},
      {cac_descricao: 'Número Telefone', cac_codigo: 'phone'},
    ]
  }
}